import { connectEmptyApi as api } from '../connect-empty-api';
import { OrdersControllerGiftGetByTokenApiArg, OrdersControllerGiftGetByTokenApiResponse } from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ordersControllerGiftGetByToken: build.query<
      OrdersControllerGiftGetByTokenApiResponse,
      OrdersControllerGiftGetByTokenApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/orders/by-token/${queryArg.token}` }),
    }),

    ordersControllerReceived: build.mutation<
      any,
      {
        token: string;
      }
    >({
      query: ({ token }) => ({
        url: `/api/v1/orders/received/${token}`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as api };

export const {
  useOrdersControllerGiftGetByTokenQuery,
  useLazyOrdersControllerGiftGetByTokenQuery,
  useOrdersControllerReceivedMutation,
} = injectedRtkApi;
